import {Notifications} from "./notifications";

const SignalR = function () {
    return {
        init: () => {
            if (typeof signalR !== 'undefined') {
                const connection = new signalR.HubConnectionBuilder()
                    .withUrl("/notifications")
                    .configureLogging(signalR.LogLevel.Warning)
                    .build();

                connection.on("notification", (message, type) => {
                    switch (type) {
                        case "error":
                            Notifications.showError({ message });
                            break;
                        case "warning":
                            Notifications.showWarning({ message });
                            break;
                        default:
                            Notifications.showSuccess({ message });
                    }
                });

                connection.start().then(() => {

                }).catch(err => {
                    // return console.error(err.toString());
                });
            }
        }
    }
}();

export default SignalR;
